if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"src_components_AdminPanel_admin-routes_tsx": 1,
"src_components_App_Approvement_approvement_tsx": 1,
"src_components_App_BankShareManagement_BankShareManagement_tsx": 1,
"src_components_App_Insurance_Insurance_tsx": 1,
"src_components_App_Insurance_insurance-order_create-insurance_tsx-src_components_App_Insuranc-a0710a": 1,
"src_components_App_Insurance_insurance-order_insurance-order_tsx-src_components_App_Insurance-8ebaec": 1,
"src_components_App_Leads_Update_page_tsx-src_components_App_Leads_entities_table-columns_lead-998c9b": 1,
"src_components_App_Leads_page_tsx-src_components_App_Leads_entities_table-columns_leads-table_scss": 1,
"src_components_App_Personal_Personal_tsx": 1,
"src_components_App_PosCred_PosCredApclication_pos-cred-application_tsx": 1,
"src_components_App_PosCred_PosCreds_pos-creds_tsx": 1,
"src_components_App_Reports_index_tsx": 1,
"src_components_App_Security_SecurityList_security-list_tsx": 1,
"src_components_App_Security_SecurityRequest_security-request_tsx": 1,
"src_components_App_main-page_BankSummary_bank-summary_tsx": 1,
"src_components_App_main-page_main-page_tsx": 1,
"src_components_Auth_ResetPassword_tsx": 1,
"src_components_Auth_login_login_tsx": 1,
"src_components_Client_AutoCredit_CreateOrder_create-order_tsx": 1,
"src_components_Client_AutoCredit_Offers_offers_tsx": 1,
"src_components_Client_AutoCredit_Requests_requests_tsx": 1,
"src_components_Faq_FaqArticle_FaqArticle_tsx": 1,
"src_components_Faq_Faq_Faq_tsx": 1,
"src_components_Shared_ui_drag-and-drop_drag-and-drop_scss-src_components_Shared_widgets_servi-46645d": 1,
"src_components_Shared_widgets_helpers_serviceDeskStatusMapper_ts-src_components_Shared_widget-f06809": 1,
"src_components_Shared_widgets_index_ts-src_components_Shared_ui_drag-and-drop_drag-and-drop_s-b41174": 1,
"src_components_Shared_widgets_service-desk-request_index_ts": 1,
"vendors-node_modules_pnpm_jodit-react_5_4_72_react-dom_19_2_8_react_19_2_8__react_19_2_8_node-78848c": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload